/**
 * Auth singletons - breaks circular dependency between AuthContext and axiosInterceptor
 */
import { AuthSync, TokenManager } from 'onecall-auth-sdk';

export const authSync = new AuthSync();

// Per-tab stagger. Every tab that adopts the same token would otherwise arm its refresh timer on
// the same instant; a 0-4s spread lets the first tab's refresh and broadcast land before the
// others fire, so they re-arm instead of queueing on the refresh lock. Correctness does not
// depend on this - the lock in refreshLock.js does that - it only removes redundant rotations.
export const tokenManager = new TokenManager({
  refreshBufferSeconds: 60 + Math.floor(Math.random() * 5),
});
